<template>
  <div class="table-base">
    <v-data-table
      :headers="headers"
      :items="desserts"
      :height="needDefaultHeight ? listHeight : null"
      :loading="loading"
      fixed-header
      hide-default-footer
      :item-class="itemClass"
      calculate-widths
      item-key="id"
      class="table-border"
      must-sort
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-for="slot in Object.keys($scopedSlots)" #[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-data-table>
    <BasePagination v-bind="$attrs" v-on="$listeners" />
  </div>
</template>
<script>
import BasePagination from './BasePagination.vue'

export default {
  name: 'BaseTable',
  components: { BasePagination },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    desserts: {
      type: Array,
      required: true,
      default: () => [],
    },
    listHeight: {
      type: [String, Number],
      // default: '420',
      default: '520',
    },
    needDefaultHeight: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isBackRed: {
      type: String,
      default: '',
    },
  },
  emits: ['itemClass'],
  setup(props, { emit }) {
    // const handleUpdate = (val) => {
    //   console.log('val==', val)
    // }
    // const handleCurrentPageChange = (page) => {
    //   console.log('currentPage', page)
    // }
    const itemClass = (item) => {
      if (item.isLimit) {
        emit('itemClass', item)
        return props.isBackRed
      }
      return ''
    }
    return {
      itemClass,
      // handleUpdate,
      // handleCurrentPageChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.able-base {
  .pagination {
    color: #1a1a1a;
    &-text__desc {
      color: #5c5c5c;
    }
  }
}

.link-text {
  max-width: 220px;
  color: #0078d6;
  font-weight: 600;
  font-size: 14px;
}

.table-border {
  border: 1px solid #dbdbdb;
  border-top: 0;
}
:deep(.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover)
    .v-btn__content) {
  opacity: 1;
}
</style>
